import angular from 'angular'
import FileManager from 'emun.filemanager/file-manager'

const dependencies = ['emun.auth','webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('emun.filemanager', dependencies)
	.component('fileManager', FileManager)
	.name;